import { INotification } from './i-notification.interface';
import { INotificationCategory } from './i-notificationcategory.interface';

import { Notification } from './notification.model';

export class NotificationCategory implements INotificationCategory {
	constructor(name: string, notifications: Array<Notification>) {
		this.name = name;
		this.notifications = notifications;
		this.expanded = false;
	}
	name: string;
	notifications: Array<Notification>;
	expanded: boolean;
	get count(): number {
		return this.notifications.filter(x => !x.dismissed).length;
	}
	get dismissedCount(): number {
		return this.notifications.filter(x => x.dismissed).length;
	}
}